export default class SchedulePeriodFile {

    constructor() {
        this.id = 0;
        this.fileId = 0;
        this.videoId = 0;
        this.schedulePeriodId = 0;
        this.schedulePeriodFileTypeId = 0;
        this.file = {};
        this.video = {};
    }
}